export default "__VITE_ASSET__Bb5OfXdx__"